import Vue from 'vue'
import store from '@/store'


function FilterEngineV2(){
  const that = this

  // Variables
  this.c = null // config
  this.getMetrics = null // getMetrics function
  this.lgSize = 3 // lg size of the components // DEPRECATED
  that.savedSelectionList = {} // saved selection list
  that.preSelected = {} // preselected values
  that.abortController = null
  //Vuex store functions
  this.store = {
    get: {
      config(configName){
        const f = store.getters['filterV2/getFilterConfig']
        return f(configName)
      },
      apiRulesOfComponent(componentName){
        const f = store.getters['filterV2/getAPIRules']
        return f(componentName)
      },
      // filterData(){
      //   return  store.getters['filterV2/getFilterData']
      // },
      // previousFilterData(){
      //   return  store.getters['filterV2/getPreviousFilterData']
      // },

      // --- Modify filterData getter ---
      async filterData() { // Becomes async
        // Dispatch action, assumes it returns { current, previous }
        const { current } = await store.dispatch('filterV2/loadFiltersFromDB');
        return current; // Return the 'current' part
      },

      // --- Modify previousFilterData getter ---
      async previousFilterData() { // Becomes async
        // Dispatch action, assumes it returns { current, previous }
        const { previous } = await store.dispatch('filterV2/loadFiltersFromDB');
        return previous; // Return the 'previous' part
      },
      apiData(){
        return store.getters['filterV2/getApiData']
      },
      hierarchy() {
        return store.getters['filterV2/getHierarchy']
      },
      loadingStatus(componentName){
        return store.getters['filterV2/getLoadingStatus'](componentName)
      }
    },
    set : {
      apiData(apiData){
        store.commit('filterV2/setApiData', apiData)
      },
      hierarchy(hierarchy){
        store.commit('filterV2/setHierarchy', hierarchy)
      },
      changeLoadingStatus(componentName,loading){
        store.commit('filterV2/changeLoadingStatus', {componentName,loading})
      },
      
      // filterData(filterData){
      //   store.commit('filterV2/setFilterData', filterData)
      // },
      // previousFilterData(filterData){
      //   store.commit('filterV2/setPreviousFilterData', filterData)
      // },
      // updateSelectedValue(payload){
      //   store.commit('filterV2/updateSelectedValue', payload)
      // },
      // updateComponentFilterData(payload){
      //   store.commit('filterV2/updateComponentFilterData', payload)
      // },

      async filterData(filterData) {
        await store.dispatch('filterV2/saveCurrentFilterDataAction', filterData);
      },

      async previousFilterData(filterData) {
        await store.dispatch('filterV2/savePreviousFilterDataAction', filterData);
      },

      async updateSelectedValue(payload) {
        await store.dispatch('filterV2/updateComponentSelectionAction', payload);
      },

      async updateComponentFilterData(payload) { // Becomes async
        await store.dispatch('filterV2/updateComponentObjectAction', payload);
      },

    }
  }

  // api functions
  this.api = {
    async get(url, params) {
      const preparedParams =  await that.api.prepareParams(params)

      return Vue.prototype.$http.get(url, { params: preparedParams })
        .then(response => {
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    async getSavedSelection(selectionName){
      return Vue.prototype.$http.get("global/filters/filter_saved_selections",
        {
          params :{
            selectionName: selectionName,
            configName: that.configName
          }
        }
      ).then(response => {
        return response.data
      }).catch(() => {
        return []
      })
    },
    async selectionActionsAPI(action,postBody){
      return Vue.prototype.$http.post("global/filters/filter_saved_selections",postBody, {
        params:{
          action: action,
          configName:  that.configName
        }
      }).then(() => true).catch(() => false)
    },
    async prepareParams(params) { 
      async function replaceVariables(template) {
          // If the input isn't a string, return it directly
          if (typeof template !== 'string') {
              return template;
          }
  
          // Use a regex to find all potential variables
          const matches = [...template.matchAll(/\$(\w+)\$/g)];
  
          if (matches.length === 0) {
              return template; // No variables found, return original
          }
  
          // Extract unique variable names
          const uniqueVarNames = [...new Set(matches.map(match => match[1]))];
  
          // Create an array of Promises for fetching values
          const valuePromises = uniqueVarNames.map(async (varName) => {
              try {
                  // 3. Use 'that' directly as in the original snippet
                  const val = await that.manage.component.general.getValue(varName);
                  return { name: varName, value: val };
              } catch (error) {
                  console.error(`Error fetching value for variable '${varName}':`, error);
                  return { name: varName, value: undefined }; // Handle error
              }
          });
  
          // Wait for all fetch operations to complete
          const resolvedValues = await Promise.all(valuePromises); // 4. Wait here
  
          // Create a map of variable names to their fetched values
          const valueMap = new Map();
          resolvedValues.forEach(item => {
              // Only map non-null/undefined values, as per original logic
              if (item.value !== null && item.value !== undefined) {
                  valueMap.set(item.name, item.value);
              }
          });
  
          // 5. Perform the replacement synchronously using the fetched values
          return template.replace(/\$(\w+)\$/g, (match, varName) => {
              const val = valueMap.get(varName);
              // Replace if value exists in map, otherwise keep original placeholder
              return valueMap.has(varName) ? val : match;
          });
      } // End of replaceVariables
  
      const preparedParams = {};
      // 6. Iterate through the parameters
      for (const [key, value] of Object.entries(params)) {
          if (value !== null) {
              // 7. Await the result of the async replaceVariables function
              preparedParams[key] = await replaceVariables(value);
          }
      }
      // 8. Return the object with processed values
      return preparedParams;
  },
    prepareAPIRules(){
      let apiRules = {}
      let apiNameMap = {}
      for (const apiUrl in that.c.apiRules) {
        for (const name in that.c.apiRules[apiUrl]) {
          const component = that.c.apiRules[apiUrl][name]
          apiRules[name] = {
            apiUrl: apiUrl,
            responseKey: component.responseKey,
            params: component.params
          }
          apiNameMap[component.responseKey] = name
        }
      }
      return {apiRules,apiNameMap}
    }
  }

  // filter management functions
  this.manage = {
    hierarchy : {

      getVisualHierarchy(){

        function flattenArray(data) {
            return data.reduce((acc, val) => Array.isArray(val) ? acc.concat(flattenArray(val)) : acc.concat(val), []);
        }
        function adjustArray(array) {
          // Eğer dizi 1. dereceden ve içinde dizi barındırmıyorsa, tüm diziyi tek bir eleman olarak içeren bir dizi döndür
          if (!array.some(Array.isArray)) {
            return [array];
          }
          // Eğer dizi içinde dizi barındırıyorsa, her elemanı kontrol et ve dizi olmayanları diziye çevir
          return array.map(element => Array.isArray(element) ? element : [element]);
        }
        let visual = undefined
        if (that.c.hasOwnProperty("visualHierarchy")){
          visual =  that.c.visualHierarchy
        }else{
          visual = flattenArray(that.c.hierarchy)
        }

        return adjustArray(visual)
      },
      // Create a dictionary of the hierarchy
      makeHierarchyDict(array = that.c.hierarchy, level = 0, pathId = 0, result = {}) {
      array.forEach((item, index) => {
       if (Array.isArray(item)) {
         that.manage.hierarchy.makeHierarchyDict(item, level + 1, pathId, result);
       } else {
         result[item] = { hierarchyLevel: level, pathId };
       }
       if (level === 0) pathId++;
      });
      return result;
      },
      findElementsAndMaxLevelForPathId(pathId) {
      let groupedElements = {};
      let maxLevel = 0;
      for (const key in that.hierarchy()) {
       if (that.hierarchy()[key].pathId === pathId) {
         const level = that.hierarchy()[key].hierarchyLevel;
         maxLevel = Math.max(maxLevel, level);

         if (!groupedElements[level]) {
           groupedElements[level] = [];
         }
         groupedElements[level].push(key);
       }
      }
      return { elements: groupedElements, maxHierarchyLevel: maxLevel };
      },
      getElements(componentName){
      const compPath = that.manage.hierarchy.getPathId(componentName)
      const {elements, maxHierarchyLevel} = that.manage.hierarchy.findElementsAndMaxLevelForPathId(compPath)
      return elements
      },
      getHierarchyLevel(componentName){
      return that.hierarchy()[componentName].hierarchyLevel
      },
      getPathId(componentName){
      return that.hierarchy()[componentName].pathId
      },
      async isMomFilled(componentName){
        const elements = that.manage.hierarchy.getElements(componentName)
        const hierarchyLevel = that.manage.hierarchy.getHierarchyLevel(componentName)
        if(hierarchyLevel === 1){
         return true
        }else{
         for (let i = 1; i < hierarchyLevel; i++) {
           const moms = elements[i]
           for (const mom of moms) {
             if (!await that.utils.isFilled(mom)) {
               return false
             }
           }
         }
         return true
        }
      },
      getMoms(componentName){
        const elements = that.manage.hierarchy.getElements(componentName)
        const hierarchyLevel = that.manage.hierarchy.getHierarchyLevel(componentName)
        const moms = []
        for (let i = 1; i < hierarchyLevel; i++) {
          const mom = elements[i]
          moms.push(...mom)
        }
        return moms
      },
      async isAllNecessaryComponentsFilled() {
        for (const componentName in that.hierarchy()){
          const filterData = await that.store.get.filterData()
          if ((filterData[componentName].rules.isNecessary) &&
            (!await that.utils.isFilled(componentName))){
            return false
          }
        }
        return true
      },
     },
    filterData : {
       async resetAll(){
         await that.store.set.filterData({})
       },
      async getComponentData(componentName){
        const apiRules = that.store.get.apiRulesOfComponent(componentName)
        
        if (apiRules == undefined || !apiRules.hasOwnProperty("params")) {
          return null
        }else{
        //const apiParams = that.api.prepareParams(apiRules.params)
        const apiResponse = await that.api.get(apiRules.apiUrl,apiRules.params)
        return apiResponse[apiRules.responseKey]
        }

      },
      // Returns previous selection if it's still valid in current component data. Matches components by name or dataType
      async getValidPreviousSelection(componentName, compData){
        const previousFilterData = await that.store.get.previousFilterData();
        if(!previousFilterData){
          return null
        }
        const componentConfig = that.c.components[componentName]

        const previousEntry = Object.entries(previousFilterData).find(([key,value]) => {
          const oldDataType = value.properties?.dataType;
          const configDataType = componentConfig.properties?.dataType;
          
          // Create arrays of identifiers for both previous and current(dataType and componentName)
          const previousIdentifiers = [oldDataType, key].filter(Boolean); // filter(Boolean) removes null/undefined
          const currentIdentifiers = [configDataType, componentName].filter(Boolean);

           // Check if any identifier matches between the arrays
          return previousIdentifiers.some(prevId => 
            currentIdentifiers.some(currId => prevId === currId)
          );
        });

        let previousSelected = previousEntry?.[1]?.selected
         
        // Check if the selected value is present in the new data
        if(compData?.length && previousSelected){
          const isSelectedPresent = compData.some(item => item.value === previousSelected.value)
          previousSelected = isSelectedPresent ? previousSelected : null
        }else {
          previousSelected = null;
        }

        return previousSelected
      },
      async updateComponentData(componentName){
        that.store.set.changeLoadingStatus(componentName,true)
        const componentConfig = that.c.components[componentName]
        let compData = await that.manage.filterData.getComponentData(componentName)
        //rules check
        compData = that.manage.component[componentConfig.type].defaultEntry(componentName,compData)
        compData = that.manage.component[componentConfig.type].deleteEntry(componentName,compData)
        
        const previousSelected = await that.manage.filterData.getValidPreviousSelection(componentName,compData)
        const selected = previousSelected ?? that.manage.component[componentConfig.type].selectFirst(componentName, compData);

        await that.store.set.updateComponentFilterData({
          type: componentConfig.type,
          properties: componentConfig.properties,
          data : compData,
          selected: selected,
          rules: componentConfig.rules,
          name: componentName,
        })
        that.store.set.changeLoadingStatus(componentName,false)
      },
      preSelectFilterData : async function(){ // it can be merged with prepareFilterData and importSelection
        const selectedSelection = that.preSelected
        const hierarchy = that.store.get.hierarchy()
        await that.manage.filterData.resetAll()

        var isThereSubmitBtn = null
        for (const [componentName, compHierarchy] of Object.entries(hierarchy)) {
          const compType = that.c.components[componentName].type
          await that.manage.filterData.updateComponentData(componentName)
          if (compType === "selectDate" || compType === "checkBox"){
            continue
          }
          if (selectedSelection.hasOwnProperty(componentName)){
            await that.store.set.updateSelectedValue({
              name: componentName,
              selected: selectedSelection[componentName],
            })
          }
            if (compType === "submit"){
              isThereSubmitBtn = componentName
            }
        }
        if (isThereSubmitBtn !== null){
          that.manage.component.general.input(isThereSubmitBtn,true)
        }
      },
      prepareFilterData: async function () {
        const oldFilterData = await that.store.get.filterData()
        await that.store.set.previousFilterData(oldFilterData)
        const hierarchy = that.store.get.hierarchy()
        await that.manage.filterData.resetAll()
        for (const [componentName, compHierarchy] of Object.entries(hierarchy)) {
          const componentConfig = that.c.components[componentName]
          const isExistInOldFilterData = oldFilterData?.hasOwnProperty(componentName)
          const isMomFilled = await that.manage.hierarchy.isMomFilled(componentName)


          if (!isExistInOldFilterData || !componentConfig.rules.autoload) {
            if (isMomFilled) {
              await that.manage.filterData.updateComponentData(componentName)
            } else {
              await that.store.set.updateComponentFilterData({
                type: componentConfig.type,
                properties: componentConfig.properties,
                data: [],
                selected: null,
                rules: componentConfig.rules,
                name: componentName,
              })
            }
          } else { // it is ready to check for loading from old filterdata
            if (isMomFilled) {
              const moms = that.manage.hierarchy.getMoms(componentName)
              const isAllMomInOldFilterData = moms.every(mom => oldFilterData.hasOwnProperty(mom))

              if (isAllMomInOldFilterData) {
                oldFilterData[componentName].properties = componentConfig.properties
                oldFilterData[componentName].rules = componentConfig.rules
                oldFilterData[componentName].data = that.manage.component[componentConfig.type].defaultEntry(componentName,oldFilterData[componentName].data)
                oldFilterData[componentName].data = that.manage.component[componentConfig.type].deleteEntry(componentName,oldFilterData[componentName].data)
                if(!that.manage.component[componentConfig.type].isSelectedInData(oldFilterData[componentName].selected,oldFilterData[componentName].data)){
                  //console.log("selected is not in data",componentName,oldFilterData[componentName].selected,oldFilterData[componentName].data)
                  oldFilterData[componentName].selected = that.manage.component[componentConfig.type].selectFirst(componentName,oldFilterData[componentName].data)
                }
                if((componentConfig.rules.selectFirst) && (oldFilterData[componentName].selected === null)){
                  //console.log("selected is null",componentName,oldFilterData[componentName].selected,oldFilterData[componentName].data)
                  await that.manage.filterData.updateComponentData(componentName)
                }else{
                  await that.store.set.updateComponentFilterData(oldFilterData[componentName])
                }

              } else {
                await that.manage.filterData.updateComponentData(componentName)
              }
            } else {
              await that.store.set.updateComponentFilterData({
                type: componentConfig.type,
                properties: componentConfig.properties,
                data: [],
                selected: null,
                rules: componentConfig.rules,
                name: componentName,
              })
            }
          }
        }
      },
      importSelection : async function (selectionName){
        const selectedSelection = that.savedSelectionList[selectionName]
        const hierarchy = that.store.get.hierarchy()
        await that.manage.filterData.resetAll()

        var isThereSubmitBtn = null
        for (const [componentName, compHierarchy] of Object.entries(hierarchy)) {
          const compType = that.c.components[componentName].type
          await that.manage.filterData.updateComponentData(componentName)
          if (compType === "selectDate" || compType === "checkBox"){
            continue
          }
          if (selectedSelection.hasOwnProperty(componentName)){
          await that.store.set.updateSelectedValue({
            name: componentName,
            selected: selectedSelection[componentName],
          })
          }
          if (compType === "submit"){
            isThereSubmitBtn = componentName
          }
        }
        if (isThereSubmitBtn !== null){
          that.manage.component.general.input(isThereSubmitBtn,true)
        }

      },
      selectionActions : async function (selectionName,action){
        if (action === "delete"){
          return await that.api.selectionActionsAPI("delete",{saveName: selectionName})
        }else if (action === "update")  {
          const params =  that.manage.metrics.getParams()
          that.savedSelectionList[selectionName] = params
          return await that.api.selectionActionsAPI("update",{saveName: selectionName,selections: params})
        }else if (action === "add")  {
          const params =  that.manage.metrics.getParams()
          that.savedSelectionList[selectionName] = params
          return await that.api.selectionActionsAPI("add",{saveName: selectionName,selections: params})
        }
      }
    },
    component : {
      general:{
        async prepareForNewSelectList(componentName) {
          const {elements, maxHierarchyLevel } = that.manage.hierarchy.findElementsAndMaxLevelForPathId(
            that.hierarchy()[componentName].pathId)
          for (let hierarchyLevel = that.hierarchy()[componentName].hierarchyLevel +1 ; hierarchyLevel <= maxHierarchyLevel; hierarchyLevel++) {
            const daughters = elements[hierarchyLevel]
            for (const daughter of daughters) {
              const filterData = await that.store.get.filterData();
              const componentFilterData = filterData[daughter]
              if (await that.manage.hierarchy.isMomFilled(daughter)) {
                await that.manage.filterData.updateComponentData(daughter)
              }else{
                componentFilterData.selected = null
                componentFilterData.data = []
                await that.store.set.updateComponentFilterData(componentFilterData)
              }
            }
          }
        },
        async getValue(componentName){
          const filterData = await that.store.get.filterData();
          const compData = filterData[componentName]
          return that.manage.component[compData.type].getValue(compData)
        },
        async input(componentName,selected){
          const componentConfig = that.c.components[componentName]
          await that.manage.component[componentConfig.type].input(componentName,selected)
          await that.manage.metrics.checkAndExecute()
          that.manage.component.general.componentDataReset()
        },
        async componentDataReset(){
          for (const [componentName, compHierarchy] of Object.entries(that.hierarchy())) {
            const componentConfig = that.c.components[componentName]
            if (componentConfig.type === "submit"){ // daha sonra component fonksiyonlarına taşınabilir. afterCheck
              if (componentConfig.properties.hasOwnProperty("resetActive") && componentConfig.properties.resetActive){
                await that.store.set.updateSelectedValue({
                  name: componentName,
                  selected: null,
                })
              }
            }
          }
        },
        calculateSizeOfComponents(){ //DEPRECATED
          const n = Object.keys(that.c.components).length
          const actualSize = 12/n
          let size = Math.floor(actualSize)
          if (size < 2){
            size =  2
          }
          that.lgSize = size
        }
      },
      selectList : {
        async input(componentName,selected){
          await that.store.set.updateSelectedValue({
            name: componentName,
            selected: selected,
          })
          await that.manage.component.general.prepareForNewSelectList(componentName)
        },
        selectFirst(componentName,data){
          const componentConfig = that.c.components[componentName]
          if(componentConfig.rules.selectFirst && !that.utils.isEmptyArray(data)){
            return data[0]
          }else {
            return null
          }
        },
        defaultEntry(componentName,data){
          const componentConfig = that.c.components[componentName]
          if(!that.utils.isEmptyObject(componentConfig.rules.defaultEntry)){ //todo: check is it object or array
            const newData = [...componentConfig.rules.defaultEntry,...data]
            return that.manage.component.selectList.removeDuplicatesInArray(newData)
          }else{
            return data
          }
        },
        deleteEntry(componentName,data){
          const componentConfig = that.c.components[componentName]
          if(!that.utils.isEmptyObject(componentConfig.rules.deleteEntry)){
              // data =  data.filter(mainItem =>
              //   !componentConfig.rules.deleteEntry.some(deleteItem =>
              //     (typeof deleteItem === 'object' && deleteItem.value === mainItem.value) || deleteItem === mainItem
              //   )
              // )
              data = data.filter(mainItem =>
                !componentConfig.rules.deleteEntry.some(deleteItem =>
                  (typeof deleteItem === 'object' && 
                   (deleteItem.value === mainItem.value || deleteItem.title === mainItem.title)) || 
                  deleteItem === mainItem
                )
              )
            return  data
          }else{
            return data
          }
        },
        removeDuplicatesInArray(array) {
          if (array.length === 0 || typeof array[0] === 'string') {
            return [...new Set(array)];
          }
          return array.reduce((acc, current) => {
            if (!acc.some(item => item.value === current.value)) {
              acc.push(current);
            }
            return acc;
          }, []);
        },
        async getValue(compData) {
          // const filterData = await that.store.get.filterData();
          return compData.selected.value
        },
        isSelectedInData(selected,data){
            return data.some(element =>
              typeof selected === 'object' && typeof element === 'object' ?
                selected.value === element.value :
                selected === element
            )
        }
      },
      selectCheckList : {
        async input(componentName,selected){
          await that.store.set.updateSelectedValue({
            name: componentName,
            selected: selected,
          })
          await that.manage.component.general.prepareForNewSelectList(componentName)
        },

        // selectFirst(componentName,data){
        //   const componentConfig = that.c.components[componentName]
        //   if(componentConfig.rules.selectFirst && !that.utils.isEmptyArray(data)){
        //     return data[0]
        //   }else {
        //     return null
        //   }
        // },
        selectFirst(componentName,data){
          const componentConfig = that.c.components[componentName]
          if(componentConfig.rules.selectFirst && !that.utils.isEmptyArray(data)){
            return [data[0]?.value] || []
          }else {
            return []
          }
        },
        defaultEntry(componentName,data){
          const componentConfig = that.c.components[componentName]
          if(!that.utils.isEmptyObject(componentConfig.rules.defaultEntry)){ //todo: check is it object or array
            const newData = [...componentConfig.rules.defaultEntry,...data]
            return that.manage.component.selectList.removeDuplicatesInArray(newData)
          }else{
            return data
          }
        },
        deleteEntry(componentName,data){
          const componentConfig = that.c.components[componentName]
          if(!that.utils.isEmptyObject(componentConfig.rules.deleteEntry)){
              data =  data.filter(mainItem =>
                !componentConfig.rules.deleteEntry.some(deleteItem =>
                  (typeof deleteItem === 'object' && deleteItem.value === mainItem.value) || deleteItem === mainItem
                )
              )
            return  data
          }else{
            return data
          }
        },
        removeDuplicatesInArray(array) {
          if (array.length === 0 || typeof array[0] === 'string') {
            return [...new Set(array)];
          }
          return array.reduce((acc, current) => {
            if (!acc.some(item => item.value === current.value)) {
              acc.push(current);
            }
            return acc;
          }, []);
        },
        async getValue(compData){
          const data = compData.selected;
          return Array.isArray(data) ? data : data.value;
        },
        isSelectedInData(selected,data){
            if (!Array.isArray(data)) {
                return false;
            }

            if (!selected) {
                return false;
            }

            return data.some(element => {
                if (!element) {
                    return false;
                }

                if (typeof selected === 'object' && typeof element === 'object') {
                    return selected && selected.hasOwnProperty('value') && 
                           element && element.hasOwnProperty('value') &&
                           selected.value === element.value;
                }

                return selected === element;
            });
        }
      },
      selectDate : {
        async input(componentName,selected){
          await that.store.set.updateSelectedValue({
            name: componentName,
            selected: selected,
          })
          await that.manage.component.general.prepareForNewSelectList(componentName)
        },
        async getValue(compData){
          // const filterData = await this.store.get.filterData()
          // const componentData = filterData[componentName]
          if (compData.selected !== null && typeof compData.selected.startDate !== "undefined"){
            const startDate =  compData.selected.startDate
            const endDate =  compData.selected.endDate
            return `${startDate}_${endDate}`
          }else{
            return null
          }
        },
        selectFirst(componentName,data){
          const componentConfig = that.c.components[componentName]
          if (componentConfig.rules.selectFirst && data.hasOwnProperty("defaultSelectedDate")){
            return data.defaultSelectedDate
          }
          return {}
        },
        deleteEntry(componentName,data){
          const componentConfig = that.c.components[componentName]
          return data
        },
        defaultEntry(componentName,data){
          const componentConfig = that.c.components[componentName]
          if (typeof componentConfig.rules.defaultEntry === "boolean" ) {
            if (componentConfig.rules.defaultEntry){
              // if( that.utils.isFilled(componentName)){
              //   //todo:api isteği atılacak
              // }
            }
            else{
              return data
            }
          }else{
            if(that.utils.isEmptyObject(componentConfig.rules.defaultEntry)){
              return data
            }else{
              return componentConfig.rules.defaultEntry
            }
          }
        },
        isSelectedInData(selected,data){
          return true //todo: range kontrolü olabilir
        }
      },
      checkBox : {
                async input(componentName,selected){
                  await that.store.set.updateSelectedValue({
                    name: componentName,
                    selected: selected,
                  })
                  await that.manage.component.general.prepareForNewSelectList(componentName)
                },
                selectFirst(componentName,data){
                  const componentConfig = that.c.components[componentName]

                  if (componentConfig.rules.defaultEntry !== false){
                    return componentConfig.rules.defaultEntry.value
                  }else {
                    return null
                  }
                  
                },
                defaultEntry(componentName,data){
                  // not logic for checkbox
                  return data
                },
                deleteEntry(componentName,data){
                  // not logic for checkbox
                  return data
                },
                async getValue(compData){
                  // const filterData = await this.store.get.filterData()
                  return compData.selected
                },
                isSelectedInData(selected,data){
                  // not logic for checkbox
                  return true
                }

      },
      submit : {
        async input(componentName,selected){
          await that.store.set.updateSelectedValue({
            name: componentName,
            selected: selected,
          })
          await that.manage.component.general.prepareForNewSelectList(componentName)

        },

        selectFirst(componentName,data){
          // not logic for submit
          return null
        },
        defaultEntry(componentName,data){
          // not logic for submit
          return data
        },
        deleteEntry(componentName,data){
          // not logic for submit
          return data
        },
        getValue(componentName){
          return null
        },
        isSelectedInData(selected,data){
          // not logic for submit
          return true
        }

}

    },
    metrics :{
      async getParams(){
        const params = {}
        const filterData = await that.store.get.filterData()
        for (const [key, value] of Object.entries(filterData)) {
          if (value.selected !== null) {
            if ((value.type === "selectCheckList") && (value?.properties?.sendNoneForSelectAll) && (value.selected?.length === value.data?.length)){
              params[key] = null
            }else{
              params[key] = value.selected
            }
          }
        }
        console.log(params)
        return params
      },
      setFuncHandler(getMetrics){
        that.getMetrics = getMetrics
      },
      async getMetrics(){
        if(that.getMetrics !== null && that.getMetrics !== undefined){
           
          if (that.abortController) {
            that.abortController.abort();
          }
          
          that.abortController = new AbortController();
          const signal = that.abortController.signal;

          const params = await that.manage.metrics.getParams();

          Vue.prototype.$http.defaults.signal = signal;

          try {
            await that.getMetrics(params);
          } catch (e) {
            if (e.name === 'CanceledError' || e.message === 'canceled') {
              console.log('Request was canceled');
            } else {
              console.error(e);
            }
          } finally {
            // Cleanup
            delete Vue.prototype.$http.defaults.signal;
            that.abortController = null;
          }
        }

      },
      async isReady(){
        //check if all necessary components are ready to getMetrics
        return await that.manage.hierarchy.isAllNecessaryComponentsFilled()
      },
      async checkAndExecute(){
        const isReady = await that.manage.metrics.isReady()
        if(isReady){
          that.manage.metrics.getMetrics()
        }
      }
    }
  }
  this.utils = {
    isEmptyObject(obj) {
      if (typeof obj !== "object") {
        return false // don't affect && chain
      }
      for (const prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
          return false // not empty
        }
      }
      return true // empty
    },
    isEmptyArray(arr) {
      if (typeof arr !== "object") {
        return false // don't affect && chain
      }
      return arr.length === 0
    },
    async isFilled(componentName) {
      const filterData = await that.store.get.filterData()
      const compData = filterData[componentName]
      // FILL DEFINITION
      return compData.hasOwnProperty("selected") && // HAS SELECTED PROPERTY
        typeof compData.selected !== "undefined" && // NOT UNDEFINED
        compData.selected !== null && // NOT NULL
        compData.selected !== "" && // NOT EMPTY STRING
        !that.utils.isEmptyArray(compData.selected) && // NOT EMPTY ARRAY
        !that.utils.isEmptyObject(compData.selected) // NOT EMPTY OBJECT
    },
  }

  this.initialize = async function(configName, getMetricFunc, savedSelection = null){
    const oldFilterData = await that.store.get.filterData()
    that.savedSelectionList = []
    var canBeSaved = false
    that.configName = configName
    that.c = that.readConfig(configName)
    this.manage.component.general.calculateSizeOfComponents()
    that.manage.metrics.setFuncHandler(getMetricFunc)
    // api rules
    const apiData = that.api.prepareAPIRules()
    that.store.set.apiData(apiData)
    // hierarchy
    const hierarchyDict = that.manage.hierarchy.makeHierarchyDict()
    that.store.set.hierarchy(hierarchyDict)
    // filterData
    if (Object.keys(that.preSelected).length !== 0){
      await that.manage.filterData.preSelectFilterData()
    }else{
      await that.manage.filterData.prepareFilterData()
    }
    await that.manage.metrics.checkAndExecute()

    if (that.c.hasOwnProperty("canBeSaved") && that.c.canBeSaved){
      that.savedSelectionList = await that.api.getSavedSelection(configName)
      var canBeSaved = true
    }

    that.preSelected = {} // Reset preselected values
    const filterData = await that.store.get.filterData();
    return {
      config :filterData,
      visualHierarchy: that.manage.hierarchy.getVisualHierarchy(),
      savedSelections:  Object.keys(that.savedSelectionList),
      canBeSaved: canBeSaved
    }

  }

  this.setPreSelections = function(selections){
    that.preSelected = selections
  }
  // Shortcuts
  this.readConfig = (configName) => this.store.get.config(configName)
  this.hierarchy = () => this.store.get.hierarchy()
  // this.filterData = () => this.store.get.filterData()
}



// construction of the filter engine and binding to the vue prototype
const filterEngine= new FilterEngineV2()
Vue.prototype.$filterV2 = filterEngine

export default filterEngine